package info.rezident.app.ui.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorPalette

internal val accentColorPalette = object : ColorPalette {
    override val _50: Color =
        Color.rgb(0xFFF9E1)
    override val _100: Color =
        Color.rgb(0xFEEEB4)
    override val _200: Color =
        Color.rgb(0xFEE384)
    override val _300: Color =
        Color.rgb(0xFED951)
    override val _400: Color =
        Color.rgb(0xFECE2B)
    override val _500: Color =
        Color.rgb(0xFFC60D)
    override val _600: Color =
        Color.rgb(0xFFB703)
    override val _700: Color =
        Color.rgb(0xFFA500)
    override val _800: Color =
        Color.rgb(0xFF9400)
    override val _900: Color =
        Color.rgb(0xFF7400)
}